import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { useEffect, useState } from 'react'

function useLoggedIn() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    setIsLoggedIn(AuthUtil.isLoggedIn())
  }, [])

  return isLoggedIn
}

export default useLoggedIn
